<template lang="pug">
.home
  bw-hero
  bw-landing
  //bw-features  
  //bw-alpha-link
</template>

<script>
import BwHero from "@/components/chunks/BwHero";
//import BwAlphaLink from "@/components/chunks/BwAlphaLink";
//import BwFeatures from "@/components/chunks/BwFeatures";
import BwLanding from "@/components/chunks/BwLanding";
export default {
  components: {
    BwHero,
    //BwAlphaLink,
    //BwFeatures,
    BwLanding
  }
};
</script>

<style lang="stylus" scoped></style>
